import React from 'react'
import CustomModal from 'components/global/CustomModal'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { leagueEventStore } from 'state/league/leagueEvent'
import CustomModalFooter from 'components/global/CustomModalFooter'
import ManageDivisionForm from './ModalContent/ManageDivisionForm'

const ManageDivision: React.FC = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { manageDivisionModal, setManageDivisionModal, setDivisionData } =
    leagueEventStore(store => ({
      manageDivisionModal: store.manageDivisionModal,
      setManageDivisionModal: store.setManageDivisionModal,
      setDivisionData: store.setDivisionData,
    }))

  const closeModal = () => {
    setDivisionData(null)
    setManageDivisionModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={manageDivisionModal}
        isCloseModalCustom
        closeModal={closeModal}
        title={'Manage division'}
        footer={
          <CustomModalFooter
            multibutton
            btnAlignment="justify-between"
            btnText={'Close,Save'}
            onSubmit={handleSubmit}
            closeModal={closeModal}
          />
        }
      >
        <ManageDivisionForm form={form} />
      </CustomModal>
    </>
  )
}

export default ManageDivision
